/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Row,
  Col,
} from "@themesberg/react-bootstrap";
import { useNavigate } from "react-router-dom";
import { postApi } from "../../../redux/api";
import CustomTable from "../../../components/CustomTable";
import { formatNumber } from "../../../redux/utils";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPrint } from "@fortawesome/free-solid-svg-icons";

function ScheduleHistory() {
  const user = useSelector((state) => state.auth.user);
  const history = useNavigate();
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(
    moment().subtract(3, "months").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [showModalPdf, setShowModalPdf] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [scheduleReleases, setScheduleReleases] = useState([]);

  const getScheduleHistory = () => {
    setLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "schedule_history",
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
      .then((data) => {
        if (data.result) {
          // Data is already grouped by schedule ID from the backend
          const schedules = data.result.map((item) => ({
            schedule_id: item.cb_schedule_id,
            schedule_date: item.schedule_date,
            release_count: item.release_count,
            total_amount: parseFloat(item.total_amount || 0),
          }));
          setSchedules(schedules);
        }
      })
      .catch((err) => {
        console.error("Error fetching schedule history:", err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getScheduleHistory();
  }, []);

  const handleViewSchedule = (schedule) => {
    setLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "by_schedule_id",
        filter: schedule.schedule_id,
      },
    })
      .then((data) => {
        if (data.result) {
          setSelectedSchedule(schedule);
          setScheduleReleases(data.result);
          setShowModalPdf(true);
        }
      })
      .catch((err) => {
        console.error("Error fetching schedule releases:", err);
      })
      .finally(() => setLoading(false));
  };

  const handlePrint = () => {
    window.print();
  };

  const fields = [
    {
      title: "S/N",
      custom: true,
      component: (item, index) => <div>{index + 1}</div>,
    },
    {
      title: "Schedule ID",
      value: "schedule_id",
    },
    {
      title: "Schedule Date",
      custom: true,
      component: (item) => (
        <div>{moment(item.schedule_date).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      title: "Number of Releases",
      custom: true,
      component: (item) => <div>{item.release_count}</div>,
    },
    {
      title: "Total Amount",
      custom: true,
      component: (item) => (
        <div className="text-end">{formatNumber(item.total_amount)}</div>
      ),
    },
    {
      title: "Action",
      custom: true,
      component: (item) => (
        <div className="d-flex gap-2">
          <Button
            size="sm"
            variant="primary"
            onClick={() => handleViewSchedule(item)}
          >
            <FontAwesomeIcon icon={faEye} className="me-1" />
            View
          </Button>
        </div>
      ),
    },
  ];

  const totalAmount = scheduleReleases.reduce(
    (a, b) => a + parseFloat(b.amount),
    0
  );

  return (
    <>
      {showModalPdf ? (
        <div className="schedule-container">
          <style>
            {`
              .schedule-container {
                padding: 20px;
              }
              
              .schedule-actions {
                margin-bottom: 20px;
                display: flex;
                gap: 10px;
              }
              
              .schedule-content {
                background: white;
                padding: 40px;
                max-width: 210mm;
                margin: 0 auto;
              }
              
              .schedule-header {
                text-align: center;
                margin-bottom: 30px;
              }
              
              .schedule-logo {
                width: 80px;
                height: 70px;
                margin-bottom: 10px;
              }
              
              .schedule-title {
                font-size: 11pt;
                font-weight: bold;
                margin: 5px 0;
                text-transform: uppercase;
              }
              
              .schedule-subtitle {
                font-size: 11pt;
                font-weight: bold;
                text-decoration: underline;
                margin-top: 20px;
              }
              
              .schedule-date {
                font-size: 10pt;
                margin-top: 15px;
                margin-bottom: 20px;
                text-align: right;
              }
              
              .schedule-table {
                width: 100%;
                border-collapse: collapse;
                border: 1px solid black;
                font-size: 10pt;
              }
              
              .schedule-table th,
              .schedule-table td {
                border: 1px solid black;
                padding: 8px;
                text-align: left;
              }
              
              .schedule-table th {
                font-weight: bold;
                text-align: center;
                background: white;
              }
              
              .schedule-table td:last-child,
              .schedule-table th:last-child {
                text-align: right;
              }
              
              .schedule-table .total-row {
                font-weight: bold;
              }
              
              @media print {
                /* Hide everything except the schedule content */
                body * {
                  visibility: hidden;
                }
                
                .schedule-content,
                .schedule-content * {
                  visibility: visible;
                }
                
                .schedule-content {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  padding: 20px;
                }
                
                .schedule-actions {
                  display: none !important;
                }
                
                .schedule-container {
                  padding: 0;
                }
                
                /* Hide navbar, sidebar, and other page elements */
                nav,
                .sidebar,
                .navbar,
                header,
                footer {
                  display: none !important;
                }
              }
            `}
          </style>

          <div className="schedule-actions">
            <Button onClick={() => setShowModalPdf(false)} variant="secondary">
              Go Back
            </Button>
            <Button onClick={handlePrint} variant="success">
              <FontAwesomeIcon icon={faPrint} className="me-1" />
              Print
            </Button>
          </div>

          <div className="schedule-content">
            <div className="schedule-header">
              <img
                src={require("../../../assets/img/KTSG.png")}
                alt="KTSG Logo"
                className="schedule-logo"
              />
              <div className="schedule-title">KATSINA STATE GOVERNMENT</div>
              <div className="schedule-title">
                Office of the Account-General
              </div>
              <div className="schedule-subtitle">Schedule of Releases</div>
            </div>

            <div className="schedule-date">
              <strong>Schedule ID:</strong> {selectedSchedule?.schedule_id}
              <br />
              <strong>Date:</strong>{" "}
              {moment(selectedSchedule?.schedule_date).format("DD/MM/YYYY")}
            </div>

            <table className="schedule-table">
              <thead>
                <tr>
                  <th style={{ width: "15%" }}>DATE</th>
                  <th style={{ width: "15%" }}>MDA</th>
                  <th style={{ width: "50%" }}>NARRATIONS</th>
                  <th style={{ width: "20%" }}>AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {scheduleReleases.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.approval_date}</td>
                    <td>{item.mda_name}</td>
                    <td>{item.narration}</td>
                    <td>{formatNumber(item.amount)}</td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan="3" style={{ textAlign: "right" }}>
                    TOTAL
                  </td>
                  <td>{formatNumber(totalAmount)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <div className="d-block mb-4 mb-md-0">
              <h4>Schedule History</h4>
            </div>
            <div className="btn-toolbar mb-2 mb-md-0">
              <Button
                variant="secondary"
                onClick={() => history("/approval-collection/ag-approved")}
              >
                Back to AG Approved
              </Button>
            </div>
          </div>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group id="date_to">
                <Form.Label>Date To</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={4} className="d-flex align-items-end">
              <Button onClick={getScheduleHistory} disabled={loading}>
                {loading ? "Loading..." : "Filter"}
              </Button>
            </Col>
          </Row>

          <Card
            border="light"
            className="table-wrapper table-responsive shadow-sm"
          >
            <Card.Body className="p-0">
              {loading ? (
                <div className="d-flex justify-content-center p-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <div style={{ height: "60vh", overflow: "scroll" }}>
                  <CustomTable fields={fields} data={schedules} />
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      )}
    </>
  );
}

export default ScheduleHistory;
